module.exports = __webpack_public_path__ + "img/camera.1962cb29.png";